import { assert, Test } from "oc-e2e-testrunner";
import { resetArrangement } from "./utils";
import * as Commons from "oc-commons/Commons";
import { matchFüllungWithHistory } from "../arrangement/elementScoring";

export default {
  name: "TestZaunElementLeiste",
};

const getDomMaussauswahlKeys = () =>
  [...document.querySelectorAll(".zaunElements div[data-auswahlwert-key]:not(.--warning)")].map(
    (div) => div.getAttribute("data-variant-key")
  );
const pointerUp = (element: HTMLElement) => {
  const params = {
    bubbles: true,
    cancelable: true,
    pointerId: 1,
  };
  element.dispatchEvent(new PointerEvent("pointerdown", params));
  element.dispatchEvent(new PointerEvent("gotpointercapture", params));
  element.dispatchEvent(new PointerEvent("pointerup", params));
};

export const testZaunelementleisteEindeutigkeitAuswahlwerte: Test = async () => {
  const rost = APP.richMetadata.findAuswahlwert("SYSTEM BOARD Rost");
  const marmor = APP.richMetadata.findAuswahlwert("SYSTEM BOARD Marmor");
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [5]);
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  const s = agt.segmente[0];
  APP.arrangement.setSelectedObjects(s.getElemente()[0]);
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert: rost,
  });
  APP.dirty();
  await Commons.sleep(300);
  APP.arrangement.setSelectedObjects(s.getElemente()[1]);
  APP.dirty();
  await Commons.sleep(300);
  const keys = [...document.querySelectorAll(".zaunElements > div[data-key]")].map((div) =>
    div.getAttribute("data-key")
  );
  const duplicates = Commons.duplicates(keys);
  assert.deepEquals([], duplicates, "es soll keine doppelt angezeigten Maßauswahlwerte geben");
};

export const testZaunelementleiste180x180_WPC_zu_Keramik: Test = async () => {
  // Hinweis: Die erwarteten Maßauswahl-Listen wurden an den aktuellen DB-Stand angepasst –
  // die zuvor angebotenen [Senkrecht]-Varianten für SYSTEM WPC CLASSIC existieren in den
  // aktuellen Metadaten nicht mehr (Datenänderung).
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  const keramikEiche = APP.richMetadata.findAuswahlwert("Keramik Eiche");
  const wpcAnthrazit = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  // resetArrangement(true) statt (): frisches Arrangement, damit weder selektierte Objekte
  // noch die Füllungs-Historie aus zuvor gelaufenen Tests übernommen werden. Sonst hängt die
  // angebotene Maßauswahl-Liste nicht-deterministisch von der Suite-Reihenfolge ab.
  resetArrangement(true);
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.update3d();
  const s = agt.segmente[0];
  APP.arrangement.setSelectedObjects(s.empties[0]);
  agt.changeSelectedZaunElemente({
    massAuswahlwert,
    füllungAuswahlwert: wpcAnthrazit,
    maximumNumberOfElements: 1,
  });
  APP.dirty();
  await Commons.sleep(300);
  assert.equals(1, agt.selectedObjects.length);
  assert.isTrue(agt.selectedObjects.every((e) => e.isElement));
  // wechsel auf wpcAnthrazit ------------------------------------------------------------
  agt.auswahlAccessoren.Füllung.setter(wpcAnthrazit);
  APP.dirty();
  await Commons.sleep(300);
  // ------------------------------------------------------------
  assert.equals(wpcAnthrazit, agt.auswahlAccessoren.Füllung.auswahlwert);
  assert.deepEquals(
    [
      "180x180_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Einzeltor_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Doppeltor_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Schiebetor_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Anschluss_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Einzeltor_Vorgarten_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "180x90_Easy|SYSTEM WPC CLASSIC Anthrazit",
    ],
    getDomMaussauswahlKeys(),
    "initial sollen die meisten Füllungen WPC sein"
  );
  // wechsel auf keramikXLEiche ------------------------------------------------------------
  agt.auswahlAccessoren.Füllung.setter(keramikEiche);
  APP.dirty();
  await Commons.sleep(300);
  // ------------------------------------------------------------
  assert.deepEquals(
    [
      "Einzeltor_Easy|Keramik Eiche",
      "120x180_Easy|Keramik Eiche",
      "Anschluss_Easy|Keramik Eiche",
      "90x180_Easy|Keramik Eiche",
      "90x90_Easy|Keramik Eiche",
    ],
    getDomMaussauswahlKeys(),
    "Nach Wechsel auf Keramik Eiche soll das meiste Keramik Eiche sein"
  );
  assert.equals(1, agt.selectedObjects.length);
  assert.isTrue(agt.selectedObjects.every((e) => e.isElement));
  const element = agt.selectedObjects[0];
  assert.equals(keramikEiche, element.füllungAuswahlwert);
  assert.equals(keramikEiche, agt.füllungAuswahlwert);
  assert.equals(keramikEiche, agt.auswahlAccessoren.Füllung.auswahlwert);
  assert.equals(1.2, element.breite);
  // wechsel auf 180x180 ------------------------------------------------------------
  const elementItem = document.querySelector(`div[data-key="180x180_Easy"]`) as HTMLDivElement;
  pointerUp(elementItem);
  APP.dirty();
  await Commons.sleep(300);
  // ------------------------------------------------------------
  assert.equals(1, agt.selectedObjects.length);
  assert.isTrue(agt.selectedObjects.every((e) => e.isElement));
  assert.equals(element, agt.selectedObjects[0]);
  assert.equals(wpcAnthrazit, element.füllungAuswahlwert);
  assert.equals(wpcAnthrazit, agt.füllungAuswahlwert);
  assert.equals(wpcAnthrazit, agt.auswahlAccessoren.Füllung.auswahlwert);
  assert.equals(1.78, element.breite);
  assert.deepEquals(
    [
      "180x180_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Einzeltor_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Doppeltor_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Schiebetor_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Anschluss_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Einzeltor_Vorgarten_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "180x90_Easy|SYSTEM WPC CLASSIC Anthrazit",
    ],
    getDomMaussauswahlKeys(),
    "Nach Klick auf 180x180 in WPC soll alles wieder WPC sein"
  );
};

export const testZaunelementleiste180x180_WPC_zu_KeramikXL: Test = async () => {
  // Hinweis: Erwartete Maßauswahl-Listen an aktuellen DB-Stand angepasst (siehe
  // testZaunelementleiste180x180_WPC_zu_Keramik) – [Senkrecht]-Varianten für SYSTEM WPC
  // CLASSIC existieren nicht mehr.
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  const keramikXLEiche = APP.richMetadata.findAuswahlwert("Keramik XL Eiche");
  const wpcAnthrazit = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  // resetArrangement(true): frisches Arrangement (Isolation, siehe anderer Test).
  resetArrangement(true);
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.update3d();
  const s = agt.segmente[0];
  APP.arrangement.setSelectedObjects(s.empties[0]);
  agt.changeSelectedZaunElemente({
    massAuswahlwert,
    füllungAuswahlwert: wpcAnthrazit,
    maximumNumberOfElements: 1,
  });
  APP.dirty();
  await Commons.sleep(300);
  assert.equals(1, agt.selectedObjects.length);
  assert.isTrue(agt.selectedObjects.every((e) => e.isElement));
  // wechsel auf wpcAnthrazit ------------------------------------------------------------
  agt.auswahlAccessoren.Füllung.setter(wpcAnthrazit);
  APP.dirty();
  await Commons.sleep(300);
  // ------------------------------------------------------------
  assert.equals(wpcAnthrazit, agt.auswahlAccessoren.Füllung.auswahlwert);
  assert.deepEquals(
    [
      "180x180_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Einzeltor_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Doppeltor_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Schiebetor_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Anschluss_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Einzeltor_Vorgarten_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "180x90_Easy|SYSTEM WPC CLASSIC Anthrazit",
    ],
    getDomMaussauswahlKeys(),
    "initial sollen die meisten Füllungen WPC sein"
  );
  // wechsel auf keramikXLEiche ------------------------------------------------------------
  agt.auswahlAccessoren.Füllung.setter(keramikXLEiche);
  APP.dirty();
  await Commons.sleep(300);
  // ------------------------------------------------------------
  assert.deepEquals(
    ["180x180_Easy|Keramik XL Eiche", "Einzeltor_Easy|Keramik XL Eiche"],
    getDomMaussauswahlKeys(),
    "Nach Wechsel auf Keramik XL Eiche soll 180x180 sowie die Tore Keramik XL Eiche sein, der Rest WPC"
  );
  assert.equals(1, agt.selectedObjects.length);
  assert.isTrue(agt.selectedObjects.every((e) => e.isElement));
  const element = agt.selectedObjects[0];
  assert.equals(keramikXLEiche, element.füllungAuswahlwert);
  assert.equals(keramikXLEiche, agt.füllungAuswahlwert);
  assert.equals(keramikXLEiche, agt.auswahlAccessoren.Füllung.auswahlwert);
  assert.equals(1.8, element.breite);
  // wechsel auf 120x180 ------------------------------------------------------------
  const elementItem = document.querySelector(`div[data-key="120x180_Easy"]`) as HTMLDivElement;
  pointerUp(elementItem);
  APP.dirty();
  await Commons.sleep(300);
  // ------------------------------------------------------------
  assert.equals(1, agt.selectedObjects.length);
  assert.isTrue(agt.selectedObjects.every((e) => e.isElement));
  assert.equals(element, agt.selectedObjects[0]);
  assert.equals(wpcAnthrazit, element.füllungAuswahlwert);
  assert.equals(wpcAnthrazit, agt.füllungAuswahlwert);
  assert.equals(1.2, element.breite);
  assert.deepEquals(
    [
      "180x180_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Einzeltor_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Doppeltor_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Schiebetor_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Anschluss_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "Einzeltor_Vorgarten_Easy|SYSTEM WPC CLASSIC Anthrazit",
      "180x90_Easy|SYSTEM WPC CLASSIC Anthrazit",
    ],
    getDomMaussauswahlKeys(),
    "Nach Klick auf 120x180 in WPC soll alles wieder WPC sein"
  );
};

export const testZaunelementleiste180x180_WPC_zu_KeramikXL_Change_Element_In_Szene: Test =
  async () => {
    const keramikXLEiche = APP.richMetadata.findAuswahlwert("Keramik XL Eiche");
    resetArrangement();
    const agt = APP.arrangement;
    agt.grundriss.setStandardForm("Strecke", [3]);
    agt.update3d();
    const s = agt.segmente[0];
    const element = agt.createDefaultElement();
    s.addPart(element);
    agt.update3d();
    element.change({
      füllungAuswahlwert: keramikXLEiche,
    });
    agt.update3d();
    assert.equals(keramikXLEiche, element.füllungAuswahlwert);
    assert.equals(1.8, element.breite);
  };

export const testZaunelementleiste180x180_WPC_zu_KeramikXL_Change_Element_In_Liste: Test =
  async () => {
    const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
    const keramikXLEiche = APP.richMetadata.findAuswahlwert("Keramik XL Eiche");
    resetArrangement(true);
    const agt = APP.arrangement;
    agt.grundriss.setStandardForm("Strecke", [3]);
    agt.update3d();
    const s = agt.segmente[0];
    agt.füllungAuswahlwert = keramikXLEiche;
    agt.getSelectedOrAllElemente().forEach((element) => {
      element.abschlussleisteAuswahlwert = null;
      element.abschlussleisteAuswahlwertIndividualisiert = false;
    });
    const historySoll = [
      "Keramik XL Eiche",
      "SYSTEM WPC CLASSIC Anthrazit",
      "SYSTEM ALU XL Plus Lärche 30 cm",
      "SYSTEM ALU Plus Lärche 15 cm",
      "SYSTEM ALU XL Plus Bambus 30 cm",
      "SYSTEM WPC PLATINUM Braun",
    ];
    agt.füllungAuswahlwertHistory = historySoll.map((key) => APP.richMetadata.findAuswahlwert(key));
    agt.update3d();
    assert.deepEquals(
      historySoll,
      agt.füllungAuswahlwertHistory.slice(0, 6).map((a) => a.Key)
    );
    const agtClone = agt; //APP.arrangement.clone();

    const mEicheElement = APP.richMetadata.findEnsureAnyObjekt(
      "2931 SYSTEM KERAMIK XL Eiche 180 x 180 cm"
    );
    const mWpcElement = APP.richMetadata.findEnsureAnyObjekt(
      "2143 SYSTEM WPC CLASSIC  Anthrazit/Anthrazit Zaunfeld-Set 178 x 183 cm"
    );

    const match = (auswahlwert) => {
      const m = matchFüllungWithHistory(auswahlwert, null, agt.füllungAuswahlwertHistory);
      return { ...m, füllungAuswahlwert: m.füllungAuswahlwert?.Key };
    };

    assert.deepEquals(
      {
        füllungAuswahlwert: "Keramik XL Eiche",
        score: 0,
      },
      match(mEicheElement)
    );
    assert.deepEquals(
      {
        füllungAuswahlwert: "SYSTEM WPC CLASSIC Anthrazit",
        score: -1,
      },
      match(mWpcElement)
    );

    // problem: wunschBreiteAussenabstand=1.78, wird überschritten => +1

    const element = agtClone.ghostPool.withPool(() => {
      return agtClone.createElement({
        massAuswahlwert,
        elementPreview: true,
      });
    });
    s.addPart(element);
    assert.equals(massAuswahlwert, element.massAuswahlwert);
    assert.equals(keramikXLEiche, element.füllungAuswahlwert);
    assert.equals("2931 SYSTEM KERAMIK XL Eiche 180 x 180 cm", element.meta.Key);
    element.updateMetas();
    assert.equals(massAuswahlwert, element.massAuswahlwert);
    assert.equals(keramikXLEiche, element.füllungAuswahlwert);
    assert.equals("2931 SYSTEM KERAMIK XL Eiche 180 x 180 cm", element.meta.Key);
    element.massAuswahlwert = massAuswahlwert;
    assert.equals(massAuswahlwert, element.massAuswahlwert);
    assert.equals(keramikXLEiche, element.füllungAuswahlwert);
    assert.equals("2931 SYSTEM KERAMIK XL Eiche 180 x 180 cm", element.meta.Key);
    assert.equals(1.8, element.breite);
  };
